import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import config from "lib/fr-config";
import { getDeviceType } from "lib/deviceInfo";
import TextButtonView from "presentational/common/TextButtonView";
import CommonIconView from "presentational/common/CommonIconView";
import IconButtonView from "presentational/common/IconButtonView";
import UsernameSelectorModalView from "presentational/common/modals/UsernameSelectorModalView";
import TXT from "presentational/common/multinational/TXT";
import { withStyles } from "@material-ui/core/styles";
import { withStore } from "store/storeHandler";
import BottomNavigation from "@material-ui/core/BottomNavigation";
import BottomNavigationAction from "@material-ui/core/BottomNavigationAction";
import TextBrandLogoIcon from "icon/TextBrandLogoIcon";
import { getEssentialUrl } from "lib/urlQueryParser";

const CLICK_COUNT_FOR_VERSION = 30;
const SEC_TO_INIT_COUNT = 30;

const BRAND_LOGO_FONT_SIZE_FOR_DESKTOP = 14;
const HEADER_BTN_FONT_SIZE_FOR_DESKTOP = 12;

const BRAND_LOGO_FONT_SIZE_FOR_MOBILE = 16;

const desktopCss = config.css.desktop;
const mobileCss = config.css.mobile;
const colorCss = config.css.color;
const fontCss = config.css.fontThickness;
const zIndexOfHeader = config.css.zIndex.header;

const cssXL = {
  root: {
    paddingLeft: desktopCss.sidePadding,
    paddingRight: desktopCss.sidePadding,
    height: desktopCss.headerBarHeightPX,
    maxWidth: desktopCss.maximumWidth,
    minWidth: desktopCss.minimumWidth,
    backgroundColor: colorCss.colorOfBackground,
    zIndex: zIndexOfHeader.normal,

    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    margin: "auto",
    flexWrap: "wrap",

    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    alignContent: "center"
  },
  brandNameArea: {
    flex: "0 1",
    display: "flex"
  },
  voidArea: {
    flex: "1 1"
  },
  buttonArea: {
    display: "flex",
    alignItems: "center"
  },
  borderWrapper: {
    margin: "0 16px"
  },
  border: {
    height: BRAND_LOGO_FONT_SIZE_FOR_DESKTOP,

    width: 1,
    backgroundColor: "#bbbbbb"
  },
  brandNameText: { lineHeight: 1 },
  brandLogo: {
    height: BRAND_LOGO_FONT_SIZE_FOR_DESKTOP,
    verticalAlign: "bottom"
  },
  guestBtnGroup: {
    display: "flex",
    alignItems: "center"
  },
  guestCtaBtn: {
    marginLeft: 10,
    height: BRAND_LOGO_FONT_SIZE_FOR_DESKTOP + 18,
    padding: "0 14px",
    backgroundColor: colorCss.colorOfPrimary,
    color: "#fff",
    cursor: "pointer",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 8,
    boxSizing: "border-box",
    fontSize: HEADER_BTN_FONT_SIZE_FOR_DESKTOP,
    fontWeight: fontCss.medium,
    lineHeight: 1,
    WebkitTapHighlightColor: "transparent"
  },
  guestCtaIcon: {
    color: "#fff"
  }
};
const cssXS = {
  bottomNav: {
    height: `calc(env(safe-area-inset-bottom) + ${mobileCss.headerBarHeightPX}px)`,
    zIndex: 1000,

    position: "fixed",
    bottom: 0,
    width: "100%"
  },
  brandNameArea: {
    height: mobileCss.logoBarHeightPX,
    position: "relative",
    zIndex: zIndexOfHeader.normal,

    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },
  brandNameText: { lineHeight: 1, padding: 10 },
  brandLogo: {
    height: BRAND_LOGO_FONT_SIZE_FOR_MOBILE,
    verticalAlign: "bottom"
  },
  headerOptIconArea: { position: "absolute", right: mobileCss.sidePadding },
  guestBottomBar: {
    height: `calc(env(safe-area-inset-bottom) + ${mobileCss.headerBarHeightPX}px)`,
    paddingBottom: "env(safe-area-inset-bottom)",
    backgroundColor: colorCss.colorOfBackground,
    display: "flex",
    alignItems: "stretch",
    boxSizing: "border-box",

    position: "fixed",
    bottom: 0,
    width: "100%",
    zIndex: 1000
  },
  guestLeftGroup: {
    flex: "1 1 auto",
    minWidth: 0, // 중요: CTA가 커져도 왼쪽 그룹이 제대로 줄어들도록
    display: "flex",
    alignItems: "stretch"
  },
  guestItemBtn: {
    flex: "1 1 0",
    minWidth: 0,
    border: 0,
    background: "transparent",
    color: colorCss.colorOfNavBarBtnForGuest,
    borderRadius: 12,
    padding: "6px 6px 8px",
    cursor: "pointer",
    WebkitTapHighlightColor: "transparent",

    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center"
  },
  guestItemIconWrap: {
    height: 22, // 아이콘 높낮이 흔들림 방지
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  guestItemLabel: {
    marginTop: 4,
    fontSize: 10,
    fontWeight: fontCss.medium,
    lineHeight: 1.1,
    maxWidth: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  },
  guestCtaBtn: {
    flex: "0 0 auto",
    alignSelf: "center",
    margin: "8px 10px 8px 8px",
    padding: "0 14px",
    height: `calc(${mobileCss.headerBarHeightPX}px - 16px)`, // 위아래 margin 8px씩 고려
    // borderRadius: 999,
    border: 0,
    cursor: "pointer",
    WebkitTapHighlightColor: "transparent",

    backgroundColor: colorCss.colorOfPrimary,
    color: "#fff",
    boxShadow: "0 6px 18px rgba(0,0,0,0.12)",

    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 8,

    width: "55%" // 대략 이정도 하면 3버튼 길이정도 되더라.
  },
  guestCtaText: {
    minWidth: 0,
    fontSize: 12,
    fontWeight: fontCss.medium,
    lineHeight: 1.1,
    textAlign: "center",
    overflow: "hidden",
    display: "-webkit-box",
    WebkitBoxOrient: "vertical",
    WebkitLineClamp: 2
  }
};

const CustomBottomNavigation = withStyles({
  root: { backgroundColor: colorCss.colorOfBackground }
})(BottomNavigation);
const CustomBottomNavigationAction = withStyles({
  root: {
    minWidth: 55,
    transition: "initial",
    color: colorCss.colorOfUnselect,
    "&$selected": { color: "inherit" },
    padding: "6px 12px 8px",
    paddingBottom: "calc(env(safe-area-inset-bottom) + 8px)"
  },
  label: {
    fontSize: 10,
    transition: "initial",
    fontWeight: fontCss.medium,
    whiteSpace: "nowrap"
  },
  selected: { "&$label": { fontSize: 10 } }
})(BottomNavigationAction);

function HeaderView(props) {
  const { username, hasLoggedIn, NoticeModalActions } = props;
  const [selectedButton, setSelectedButton] = useState(null);
  const [countForVersion, setCountForVersion] = useState(0);
  const [usernameModalOpen, setUsernameModalOpen] = useState(false);
  const [timerId, setTimerId] = useState(null);

  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    checkCountForVersion();
    updateSelectedBtn();
  });

  const initCountForVersion = () => {
    clearTimeout(timerId);
    setCountForVersion(0);
    setTimerId(null);
  };

  const checkCountForVersion = () => {
    if (countForVersion >= CLICK_COUNT_FOR_VERSION) {
      displayVersionModal();
      initCountForVersion();
    }
  };

  const displayVersionModal = () => {
    const content = config.version;
    NoticeModalActions.openModal({ content });
  };

  const updateSelectedBtn = () => {
    const { pathname } = location;

    let newSelectedButton;
    switch (pathname) {
      case getEssentialUrl({ type: "lookbook" })():
        if (!hasLoggedIn) {
          newSelectedButton = null;
        } else {
          newSelectedButton = "lookbook";
        }
        break;
      case getEssentialUrl({ type: "search" })():
        newSelectedButton = "search";
        break;
      case getEssentialUrl({ type: "portfolio" })(username):
        newSelectedButton = "my";
        break;
      default:
        newSelectedButton = null;
        break;
    }
    setSelectedButton(newSelectedButton);
  };

  const goToOpeningPage = () => {
    const { pathname } = location;

    const type = hasLoggedIn ? "portfolio" : "opening";
    const arg1 = hasLoggedIn ? username : null;

    switch (pathname) {
      case getEssentialUrl({ type })(arg1):
        window.scrollTo(0, 0);
        break;
      default:
        history.push(getEssentialUrl({ type, allowRefParam: true })(arg1));
        break;
    }
  };

  const increaseCountForVersion = () => {
    setCountForVersion(countForVersion + 1);
    if (!timerId) {
      const newTimerId = setTimeout(
        initCountForVersion,
        SEC_TO_INIT_COUNT * 1000
      );
      setTimerId(newTimerId);
    }
  };

  const handleLogoClick = () => {
    goToOpeningPage();
    increaseCountForVersion();
  };

  const handleNavButtonClick = type => () => {
    const { pathname } = location;
    let targetURL;
    switch (type) {
      case "about":
        targetURL = getEssentialUrl({ type: "about", allowRefParam: true })();
        break;
      case "explore":
        targetURL = getEssentialUrl({ type: "opening", allowRefParam: true })();
        break;
      case "lookbook":
        targetURL = getEssentialUrl({ type: "lookbook" })();
        break;
      case "search":
        targetURL = getEssentialUrl({ type: "search" })();
        break;
      case "upload":
        targetURL = getEssentialUrl({ type: "uploadOutfit" })();
        break;
      case "logIn":
        targetURL = getEssentialUrl({ type: "account", allowRefParam: true })();
        break;
      case "portfolio":
        targetURL = hasLoggedIn
          ? getEssentialUrl({ type: "portfolio" })(username)
          : getEssentialUrl({ type: "account", allowRefParam: true })();
        break;

      default:
        throw Error(`wrong type : "${type}"`);
    }

    if (pathname === targetURL) {
      window.scrollTo(0, 0);
    } else {
      history.push(targetURL);
    }
  };

  const handleSearchUsernameClick = () => {
    setUsernameModalOpen(true);
  };

  const handleModalClose = () => {
    setUsernameModalOpen(false);
  };

  const mobileLayout = () => {
    const css = cssXS;

    return (
      <div>
        <div>
          <div style={css.brandNameArea}>
            <div style={css.brandNameText} onClick={handleLogoClick}>
              <TextBrandLogoIcon style={css.brandLogo} />
            </div>
            <div style={css.headerOptIconArea}>
              {selectedButton === "search" && (
                <div>
                  <IconButtonView
                    type={"person"}
                    onClick={handleSearchUsernameClick}
                    buttonSize={"small"}
                    fontSize={"medium"}
                  />
                </div>
              )}
            </div>
          </div>
          <CustomBottomNavigation value={selectedButton} style={css.bottomNav}>
            <CustomBottomNavigationAction
              showLabel={!hasLoggedIn}
              onClick={handleNavButtonClick("lookbook")}
              label={<TXT name="btnHeader_lookbook" />}
              value="lookbook"
              icon={<CommonIconView type={"lookbook"} />}
            />
            <CustomBottomNavigationAction
              showLabel={!hasLoggedIn}
              onClick={handleNavButtonClick("search")}
              label={<TXT name="btnHeader_search" />}
              value="search"
              icon={<CommonIconView type={"search"} />}
            />
            <CustomBottomNavigationAction
              showLabel={!hasLoggedIn}
              onClick={handleNavButtonClick("upload")}
              label={<TXT name="btnHeader_upload" />}
              value="upload"
              icon={<CommonIconView type={"addCircle"} />}
            />
            <CustomBottomNavigationAction
              showLabel={!hasLoggedIn}
              onClick={handleNavButtonClick("portfolio")}
              label={<TXT name="btnHeader_portfolio" />}
              value="my"
              icon={<CommonIconView type={"portfolio"} />}
            />
          </CustomBottomNavigation>
        </div>
        <UsernameSelectorModalView
          open={usernameModalOpen}
          onClose={handleModalClose}
          disabled={selectedButton !== "search"}
        />
      </div>
    );
  };

  const mobileLayoutForGuest = () => {
    const css = cssXS;

    return (
      <div>
        <div>
          <div style={css.brandNameArea}>
            <div style={css.brandNameText} onClick={handleLogoClick}>
              <TextBrandLogoIcon style={css.brandLogo} />
            </div>
          </div>
          <div style={css.guestBottomBar}>
            <div style={css.guestLeftGroup}>
              <button
                type="button"
                onClick={handleNavButtonClick("about")}
                style={css.guestItemBtn}
                aria-label="about"
              >
                <div style={css.guestItemIconWrap}>
                  <CommonIconView type={"info"} />
                </div>
                <div style={css.guestItemLabel}>
                  <TXT name="btnHeader_about" />
                </div>
              </button>
              <button
                type="button"
                onClick={handleNavButtonClick("explore")}
                style={css.guestItemBtn}
                aria-label="explore"
              >
                <div style={css.guestItemIconWrap}>
                  <CommonIconView type={"travel"} />
                </div>
                <div style={css.guestItemLabel}>
                  <TXT name="btnHeader_explorer" />
                </div>
              </button>
            </div>
            <button
              type="button"
              onClick={handleNavButtonClick("logIn")}
              style={css.guestCtaBtn}
              aria-label="login"
            >
              <CommonIconView type={"login"} />
              <span style={css.guestCtaText}>
                <TXT name="btnHeader_login" />
              </span>
            </button>
          </div>
        </div>
      </div>
    );
  };

  const desktopLayout = () => {
    const css = cssXL;

    return (
      <div>
        <div style={css.root}>
          <div style={css.brandNameArea}>
            <div style={css.brandNameText} onClick={handleLogoClick}>
              <TextBrandLogoIcon style={css.brandLogo} />
            </div>
          </div>
          <div style={css.voidArea} />
          <div style={css.buttonArea}>
            <TextButtonView
              design={selectedButton === "lookbook" ? "select" : "default"}
              fontSize={HEADER_BTN_FONT_SIZE_FOR_DESKTOP}
              paddingSize="large"
              onClick={handleNavButtonClick("lookbook")}
            >
              <TXT name="btnHeader_lookbook" />
            </TextButtonView>
            <TextButtonView
              design={selectedButton === "search" ? "select" : "default"}
              fontSize={HEADER_BTN_FONT_SIZE_FOR_DESKTOP}
              paddingSize="large"
              onClick={handleNavButtonClick("search")}
            >
              <TXT name="btnHeader_search" />
            </TextButtonView>
            <div style={css.borderWrapper}>
              <div style={css.border} />
            </div>
            <TextButtonView
              design={selectedButton === "my" ? "select" : "default"}
              fontSize={HEADER_BTN_FONT_SIZE_FOR_DESKTOP}
              paddingSize="large"
              disableRightMargin
              onClick={handleNavButtonClick("portfolio")}
            >
              <TXT name="btnHeader_portfolio" />
            </TextButtonView>
          </div>
        </div>
      </div>
    );
  };

  const desktopLayoutForGuest = () => {
    const css = cssXL;

    return (
      <div>
        <div style={css.root}>
          <div style={css.brandNameArea}>
            <div style={css.brandNameText} onClick={handleLogoClick}>
              <TextBrandLogoIcon style={css.brandLogo} />
            </div>
          </div>
          <div style={css.voidArea} />
          <div style={css.buttonArea}>
            <TextButtonView
              design={"default"}
              fontSize={HEADER_BTN_FONT_SIZE_FOR_DESKTOP}
              paddingSize="large"
              onClick={handleNavButtonClick("about")}
            >
              <TXT name="btnHeader_about" />
            </TextButtonView>
            <TextButtonView
              design={"default"}
              fontSize={HEADER_BTN_FONT_SIZE_FOR_DESKTOP}
              paddingSize="large"
              onClick={handleNavButtonClick("explore")}
            >
              <TXT name="btnHeader_explorer" />
            </TextButtonView>
            <div style={css.borderWrapper}>
              <div style={css.border} />
            </div>
            <button
              type="button"
              style={css.guestCtaBtn}
              onClick={handleNavButtonClick("logIn")}
              aria-label="login"
            >
              <CommonIconView type={"login"} style={css.guestCtaIcon} />
              <TXT name="btnHeader_login" />
            </button>
          </div>
        </div>
      </div>
    );
  };

  const render = () => {
    if (hasLoggedIn) {
      return getDeviceType() === "mobile" ? mobileLayout() : desktopLayout();
    } else {
      return getDeviceType() === "mobile"
        ? mobileLayoutForGuest()
        : desktopLayoutForGuest();
    }
  };

  return render();
}

export default withStore({
  stateMap: {
    myAccount: ["hasLoggedIn", "username"]
  },
  dispatchMap: ["noticeModal"]
})(HeaderView);
